import { LOCALES, FUTURE_LOCALES, flagUrl } from "@/i18n/translations";
import { useI18n } from "@/context/I18nContext";
import { Check, ChevronDown } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

function Flag({ cc, className = "" }) {
  return (
    <img
      src={flagUrl(cc)}
      alt={cc}
      className={`inline-block h-4 w-6 rounded-[2px] object-cover shadow-sm ${className}`}
      loading="lazy"
    />
  );
}

export function LanguageSwitcher({ dark }) {
  const { locale, setLocale } = useI18n();
  const current = LOCALES.find((l) => l.code === locale) || LOCALES[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className={`flex items-center gap-2 rounded-lg px-2.5 py-2 text-sm font-medium transition-colors ${
            dark ? "text-white/90 hover:bg-white/10" : "text-slate-600 hover:bg-slate-100"
          }`}
        >
          <Flag cc={current.cc} />
          <span className="hidden sm:inline">{current.label}</span>
          <span className="sm:hidden">{current.code.toUpperCase()}</span>
          <ChevronDown size={14} className="opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuLabel className="text-xs text-slate-400">Lingua</DropdownMenuLabel>
        {LOCALES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLocale(l.code)}
            className="cursor-pointer flex items-center gap-2.5"
          >
            <Flag cc={l.cc} />
            <span className="flex-1">{l.label}</span>
            {locale === l.code && <Check size={15} className="text-blue-700" />}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-slate-400">Presto disponibili</DropdownMenuLabel>
        {FUTURE_LOCALES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            disabled
            data-testid={`lang-soon-${l.code}`}
            className="opacity-50 cursor-not-allowed flex items-center gap-2.5"
          >
            <Flag cc={l.cc} className="grayscale" />
            <span className="flex-1">{l.label}</span>
            <span className="text-[10px] uppercase tracking-wider text-slate-400">soon</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
